import { render } from "./manualForm.vue?vue&type=template&id=4f054626"
import script from "./manualForm.vue?vue&type=script&lang=js"
export * from "./manualForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__